import React, { useState } from "react";

const AddNewCogenplant = () => {
  const [formData, setFormData] = useState({
    plant_type_id: '',
    cogen_plant_name: '',
    plant_name: '',
    plant_code: '',
    plant_address: '',
    city: '',
    tehsil: '',
    district: '',
    state: '',
    pincode: '',
    phone_number: '',
    mobile_number: '',
    email: '',
    operational_status: '',
  });

  const [errors, setErrors] = useState({});
  const [submissionStatus, setSubmissionStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateForm = () => {
    const tempErrors = {};
    if (!formData.plant_type_id) tempErrors.plant_type_id = "Please select plant type.";
    if (!formData.cogen_plant_name) tempErrors.cogen_plant_name = "Cogen plant name is required.";
    if (!formData.plant_name) tempErrors.plant_name = "Plant name is required.";
    if (!formData.plant_code) tempErrors.plant_code = "Plant code is required.";
    if (!formData.plant_address) tempErrors.plant_address = "Address is required.";
    if (!formData.city) tempErrors.city = "City is required.";
    if (!formData.tehsil) tempErrors.tehsil = "Tehsil is required.";
    if (!formData.district) tempErrors.district = "District is required.";
    if (!formData.state) tempErrors.state = "State is required.";
    if (!formData.pincode) tempErrors.pincode = "Pincode is required.";
    if (!formData.email) tempErrors.email = "Email is required.";
    if (!formData.operational_status) tempErrors.operational_status = "Operational status is required.";
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await fetch("https://backend-zkgn.onrender.com/:3002/api/cogen", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmissionStatus("Form submitted successfully!");
        setFormData({
          plant_type_id: '',
          cogen_plant_name: '',
          plant_name: '',
          plant_code: '',
          plant_address: '',
          city: '',
          tehsil: '',
          district: '',
          state: '',
          pincode: '',
          phone_number: '',
          mobile_number: '',
          email: '',
          operational_status: '',
        });
        setErrors({});
      } else {
        setSubmissionStatus("Failed to submit the form.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmissionStatus("An error occurred while submitting the form.");
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-4">Add New Cogeneration Plant</h3>
      {submissionStatus && <div className="alert alert-info">{submissionStatus}</div>}
      <form onSubmit={handleSubmit}>
        <div className="row g-3">

          <div className="col-md-6">
            <label className="form-label">Plant Type</label>
            <select className="form-select" name="plant_type_id" value={formData.plant_type_id} onChange={handleChange}>
              <option value="">-- Select --</option>
              <option value="1">Cogeneration</option>
              <option value="2">Others</option>
            </select>
            {errors.plant_type_id && <div className="text-danger">{errors.plant_type_id}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Cogen Plant Name</label>
            <input type="text" className="form-control" name="cogen_plant_name" value={formData.cogen_plant_name} onChange={handleChange} />
            {errors.cogen_plant_name && <div className="text-danger">{errors.cogen_plant_name}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Plant Name</label>
            <input type="text" className="form-control" name="plant_name" value={formData.plant_name} onChange={handleChange} />
            {errors.plant_name && <div className="text-danger">{errors.plant_name}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Plant Code</label>
            <input type="text" className="form-control" name="plant_code" value={formData.plant_code} onChange={handleChange} />
            {errors.plant_code && <div className="text-danger">{errors.plant_code}</div>}
          </div>

          <div className="col-12">
            <label className="form-label">Address</label>
            <textarea className="form-control" name="plant_address" rows="2" value={formData.plant_address} onChange={handleChange}></textarea>
            {errors.plant_address && <div className="text-danger">{errors.plant_address}</div>}
          </div>

          <div className="col-md-4">
            <label className="form-label">City</label>
            <input type="text" className="form-control" name="city" value={formData.city} onChange={handleChange} />
            {errors.city && <div className="text-danger">{errors.city}</div>}
          </div>

          <div className="col-md-4">
            <label className="form-label">Tehsil</label>
            <input type="text" className="form-control" name="tehsil" value={formData.tehsil} onChange={handleChange} />
            {errors.tehsil && <div className="text-danger">{errors.tehsil}</div>}
          </div>

          <div className="col-md-4">
            <label className="form-label">District</label>
            <input type="text" className="form-control" name="district" value={formData.district} onChange={handleChange} />
            {errors.district && <div className="text-danger">{errors.district}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">State</label>
            <input type="text" className="form-control" name="state" value={formData.state} onChange={handleChange} />
            {errors.state && <div className="text-danger">{errors.state}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Pincode</label>
            <input type="text" className="form-control" name="pincode" value={formData.pincode} onChange={handleChange} />
            {errors.pincode && <div className="text-danger">{errors.pincode}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Phone Number</label>
            <input type="text" className="form-control" name="phone_number" value={formData.phone_number} onChange={handleChange} />
          </div>

          <div className="col-md-6">
            <label className="form-label">Mobile Number</label>
            <input type="text" className="form-control" name="mobile_number" value={formData.mobile_number} onChange={handleChange} />
          </div>

          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} />
            {errors.email && <div className="text-danger">{errors.email}</div>}
          </div>

          <div className="col-md-6">
            <label className="form-label">Operational Status</label>
            <select className="form-select" name="operational_status" value={formData.operational_status} onChange={handleChange}>
              <option value="">-- Select --</option>
              <option value="Operational">Operational</option>
              <option value="Non-Operational">Non-Operational</option>
              <option value="Closed">Closed</option>
            </select>
            {errors.operational_status && <div className="text-danger">{errors.operational_status}</div>}
          </div>

        </div>

        <div className="mt-4">
          <button type="submit" className="btn btn-primary">Submit</button>
        </div>
      </form>
    </div>
  );
};

export default AddNewCogenplant;
